export const CRM_STAGES = [
  { value: 'new', text: 'Novo contato', color: 'blue-grey' },
  { value: 'negotiating', text: 'Em negociação', color: 'info' },
  { value: 'proposal', text: 'Proposta enviada', color: 'warning' },
  { value: 'won', text: 'Ganho', color: 'success' },
  { value: 'lost', text: 'Perdido', color: 'error' },
]
export const isOpenOpportunity = (item) => !['won', 'lost'].includes(item.stage)

export const canMoveOpportunityStage = (from, to) => {
  const origin = CRM_STAGES.findIndex((stage) => stage.value === from)
  const destination = CRM_STAGES.findIndex((stage) => stage.value === to)
  return origin >= 0 && destination > origin && isOpenOpportunity({ stage: from })
}
